// This class is just a tool to simplify pullnig the config values from hidden fields 
// that are rendered by MVC in the _Layout.cshtml file.  Most of them are set in the
// UI webConfig, but some of them are extracted from code (such as pulling the version 
// number from the Common Assembly)
class AppConfig {
    

    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _ALLOW_TEST_HARNESS = null;
    _DEV_MODE = null;
    _EAUTH_ENABLED = null;
    _EAUTH_LOGOFF = null;
    _HELP_EMAIL = null;
    _ROOT_PATH = null;
    _SERVICE_NOW_URL = null;
    _SHOW_DEBUG_TOOLS = null;
    _VERSION = null;
    _CURRENT_FY = null;

    // GETTERS/SETTERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // ALLOW_TEST_HARNESS
    //==================================
    get ALLOW_TEST_HARNESS(){

        if (this._ALLOW_TEST_HARNESS == null){
            let el = document.getElementById("__ALLOW_TEST_HARNESS");
            if (!el){ throw("[appConfig.js:ALLOW_TEST_HARNESS()] __ALLOW_TEST_HARNESS element not found on document" ); }
            this._ALLOW_TEST_HARNESS = !!+el.value;
        }

        return this._ALLOW_TEST_HARNESS;
    };

    //==================================
    // DEV_MODE
    //==================================
    get DEV_MODE(){

        if (this._DEV_MODE == null){
            let el = document.getElementById("__DEV_MODE");
            if (!el){ throw("[appConfig.js:DEV_MODE()] __DEV_MODE element not found on document" ); }
            this._DEV_MODE = !!+el.value;
        }

        return this._DEV_MODE;
    };

    //==================================
    // EAUTH_ENABLED
    //==================================
    get EAUTH_ENABLED(){

        if (this._EAUTH_ENABLED == null){
            let el = document.getElementById("__EAUTH_ENABLED");
            if (!el){ throw("[appConfig.js:EAUTH_ENABLED()] __EAUTH_ENABLED element not found on document" ); }
            this._EAUTH_ENABLED = ( el.value.toLowerCase() == "true" );
        }

        return this._EAUTH_ENABLED;
    };
    
    //==================================
    // EAUTH_LOGOFF
    //==================================
    get EAUTH_LOGOFF(){
        if( this._EAUTH_LOGOFF == null){
            let el = document.getElementById("__EAUTH_LOGOFF");
                        if (!el){ throw("[appConfig.js:__EAUTH_LOGOFF()] __EAUTH_LOGOFF element not found on document" ); }
            this._EAUTH_LOGOFF = el.value;
        }

        return this._EAUTH_LOGOFF;
    }

    //==================================
    // HELP_EMAIL
    //==================================
    get HELP_EMAIL(){
        if( this._HELP_EMAIL == null){
            let el = document.getElementById("__HELP_EMAIL");
                if (!el){ throw("[appConfig.js:HELP_EMAIL()] __HELP_EMAIL element not found on document" ); }
            this._HELP_EMAIL = el.value;
        }

        return this._HELP_EMAIL;
    }

    //==================================
    // ROOT_PATH
    //==================================
    get ROOT_PATH(){

        if (this._ROOT_PATH == null){
            let el = document.getElementById("__ROOT_PATH");
            if (!el){ throw("[appConfig.js:ROOT_PATH()] __ROOT_PATH element not found on document" ); }
            this._ROOT_PATH = el.value;
        }

        return this._ROOT_PATH;
    };

    //==================================
    // SERVICE_NOW_URL
    //==================================
    get SERVICE_NOW_URL(){

        if (this._SERVICE_NOW_URL == null){
            let el = document.getElementById("__SERVICE_NOW_URL");
            if (!el){ throw("[appConfig.js:_SERVICE_NOW_URL()] __SERVICE_NOW_URL element not found on document" ); }
            this._SERVICE_NOW_URL = el.value;
        }

        return this._SERVICE_NOW_URL;
    };

    //==================================
    // SHOW_DEBUG_TOOLS
    //==================================
    get SHOW_DEBUG_TOOLS(){

        if (this._SHOW_DEBUG_TOOLS == null){
            let el = document.getElementById("__SHOW_DEBUG_TOOLS");
            if (!el){ throw("[appConfig.js:SHOW_DEBUG_TOOLS()] __SHOW_DEBUG_TOOLS element not found on document" ); }
            this._SHOW_DEBUG_TOOLS = !!+el.value;
        }

        return this._SHOW_DEBUG_TOOLS;
    };

    //==================================
    // VERSION
    //==================================
    get VERSION(){

        if (this._VERSION == null){
            let el = document.getElementById("__VERSION");
            if (!el){ throw("[appConfig.js:VERSION()] __VERSION element not found on document" ); }
            this._VERSION = el.value;
        }

        return this._VERSION;
    };


    // FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    // I've had some odd "timing" problems with the getters and setters and this config object, so moving forward let's just 
    // use normal functions.  This works just fine with less complexity anyway.

    //==================================
    // CURRENT_FY
    //==================================
    CURRENT_FY() {
        if (this._CURRENT_FY == null) {
            let el = document.getElementById("__CURRENT_FY");
            if (!el){ throw("[appConfig.js:VERSION()] __CURRENT_FY element not found on document" ); }
            this._CURRENT_FY = +el.value;
        }

        return this._CURRENT_FY;
    };

    //==================================
    // ENVIRONMENT
    //==================================
    ENVIRONMENT(){
        let el = document.getElementById("__ENVIRONMENT");
        if (!el){ throw("[appConfig.js:VERSION()] __ENVIRONMENT element not found on document" ); }
        return el.value;
    };

    //==================================
    // MACHINE_NAME
    //==================================
    MACHINE_NAME(){
        let el = document.getElementById("__MACHINE_NAME");
        if (!el){ throw("[appConfig.js:VERSION()] __MACHINE_NAME element not found on document" ); }
        return el.value;
    };

    //==================================
    // X_APP_ID
    //==================================
    X_APP_ID(){
        let el = document.getElementById("__X_APP_ID");
        if (!el){ throw("[appConfig.js:VERSION()] __X_APP_ID element not found on document" ); }
        return el.value;
    };

    //==================================
    // Help_Document
    //==================================
    get HELP_DOCUMENT_LINK() {
        return "https://usdagcc.sharepoint.com/:b:/r/sites/nrcs/intranet/Shared%20Documents/Conservation%20Practice%20Data%20Entry%20System%E2%80%8B/CPDES_User_Guide.pdf";
    };

}

export const appConfig = new AppConfig();
